import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import BotApi from 'api/bot';
import NoRecords from 'components/ui/DataGrid/NoRecords';
import withContentLoader from 'components/ui/withContentLoader';
import BotCard from './BotCard';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const ExploreList = ({ data = [] }) => {
  const query = useQuery();
  const { t } = useTranslation();

  const category = query.get('category');
  const filter_price = query.get('price');

  let filtered_bots = data;

  if (category) {
    filtered_bots = filtered_bots.filter(bot => (bot.category || {}).id === category);
  }

  if (filter_price) {
    filtered_bots = filtered_bots.filter(bot => (filter_price === 'paid' ? bot.price > 0 : !bot.price || bot.price <= 0));
  }

  if (!filtered_bots.length) {
    return <NoRecords message={t('explore.no_entries')} />;
  }

  const bots = filtered_bots.map(bot => (
    <div key={bot.id} className="col-md-4 mb-4">
      <BotCard {...bot} />
    </div>
  ));

  return <div className="row">{bots}</div>;
};

const fetchData = async () => BotApi.fetchPublic();
export default withContentLoader(ExploreList, { name: 'explore_bots', fetchData });
